import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AgGridReact } from 'ag-grid-react'; // the AG Grid React Component
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomLoadingOverlay from '../../shared/component/customLoadingOverlay';
import apiServices from '../../services/service';
import { useDispatch, useSelector } from 'react-redux';
import {
  getTicketList,
  getGridDataByModuleKey,
  getGenericMasterFilteredListByKey,
  getActiveOwners,
} from '../../redux/selector';
import { isLoadingByKey } from '../../shared/controls/methods/getLoadingState';
import { fetchDataAndUpdateStore, fetchSelectedListAndAppendToModule } from '../../redux/actions';
import Loader from '../../shared/component/Loader';
import { Button } from 'react-bootstrap';
import { filterParams, ticketInputData } from '../../shared/constants';
import GlobalSearch from '../sharedChild/grid/globalSearch';
import FilterHandler from '../sharedChild/grid/filterHandler';
import useTaskColumnDefs from './useTaskColumnDefs';
import { updateGridColumnState } from '../../redux/reducer';
import gridOptionsConfig from '../sharedChild/grid/gridOptionsConfig';
import useFetchIfNeeded from '../../redux/useFetchIfNeeded';

// const OptionButton = ({
//   handleOpenEditForm,
//   paramsValue,
//   rowData,
//   handleClickDelete,
//   handleOpenViewForm,
//   hasUpdateTicketPermission,
//   hasDeleteTicketPermission,
//   hasInfoTicketPermission
// }) => {
//   const [showConfirmation, setShowConfirmation] = React.useState(false);

//   const handleDeleteClick = () => {
//     setShowConfirmation(true);
//   };

//   const handleConfirmDelete = () => {
//     handleClickDelete(paramsValue);
//     setShowConfirmation(false);
//   };

//   const handleCloseConfirmation = () => {
//     setShowConfirmation(false);
//   };

//   return (
//     <div className="action-menu">
//       {hasUpdateTicketPermission && (
//         <img
//           src="/assets/images/edit.png"
//           className="action-img1"
//           onClick={() => handleOpenEditForm(paramsValue)}
//           alt="Edit Ticket"
//           title="Edit Ticket"
//         ></img>
//       )}
//       {hasInfoTicketPermission && (
//         <img
//           src="/assets/images/view.png"
//           className="action-img2"
//           onClick={handleOpenViewForm}
//           alt="View Ticket"
//           title="View Ticket"
//         ></img>
//       )}
//       {hasDeleteTicketPermission && (
//         <img
//           src="/assets/images/trash.png"
//           className="action-img2"
//           onClick={handleDeleteClick}
//           alt="Delete Ticket"
//           title="Delete Ticket"
//         ></img>
//       )}
//       <DeleteConfirmationModal
//         show={showConfirmation}
//         handleClose={handleCloseConfirmation}
//         handleConfirm={handleConfirmDelete}
//         rowData={rowData}
//       />
//     </div>
//   );
// };

// const DeleteConfirmationModal = ({
//   show,
//   handleClose,
//   handleConfirm,
//   rowData,
// }) => {
//   return (
//     <Modal show={show} onHide={handleClose} className="modal-delete">

//       {rowData && (
//         <>
//           <div className="warning-content">
//             <div className="warningOuter">
//               <div className="alertImg"><img src="../assets/images/delete-record.png" alt="Delete Record"></img></div>
//               <div className="warningText">
//                 Are you sure you want to delete this ticket
//                 <p className="pt-2">{rowData?.subject}?</p>
//               </div>
//             </div>
//             <div className="notes">
//               *Note: Any associated Activities, Visits, Drafts will also be Deleted.
//             </div>
//             <div className="warningBtn mt-2">
//               <Button variant="secondary" className='btn' onClick={handleClose}>
//                 Cancel
//               </Button>
//               <Button className='btn' variant="danger" onClick={handleConfirm}>
//                 Confirm Delete
//               </Button>
//             </div>
//           </div>
//         </>
//       )}

//     </Modal>
//   );
// };

function Tasks() {
  const stateData = useSelector((state) => state);
  const [gridParams, setGridParams] = useState(null);
  const dispatch = useDispatch();
  let storeLoading = isLoadingByKey(stateData, 'ticketList', 'owners');
  const [filterJson, setfilterJson] = useState();

  const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
  const [selectedTheme, setSelectedTheme] = useState('balham');
  const [gridLoading, setGridLoading] = useState(false);
  const gridRef = useRef();
  const [open, setOpen] = React.useState(false);
  const rowData = useSelector(getTicketList);
  const gridData = useSelector(getGridDataByModuleKey('ticketList'));
  const [selectedRows, setSelectedRows] = useState(false);

  const [loading, setLoading] = useState(storeLoading);
  const [updateListFlag, setUpdateListFlag] = useState(false);
  const navigate = useNavigate();
  const owner = useSelector(getActiveOwners);

  const ticketPriorityDropdown = useSelector(
    getGenericMasterFilteredListByKey('TicketPriorityCrm')
  );
  const gridDataSelection = useSelector(getGridDataByModuleKey('selectionList'));
  const ticketStatusDropdown = useSelector(getGenericMasterFilteredListByKey('StatusCrm'));
  const gridOptions = gridOptionsConfig('ticketList', navigate);

  useFetchIfNeeded(getTicketList, fetchDataAndUpdateStore, {
    key: 'ticketList',
    inputData: ticketInputData,
  });

  let hasUpdateTicketPermission = true;
  let hasCreateTicketPermission = true;
  let hasDeleteTicketPermission = true;
  let hasInfoTicketPermission = true;
  let userUIControlPermission = JSON.parse(
    localStorage.getItem('userUIControlPermission')
  )?.ticketmenu;

  if (userUIControlPermission) {
    hasCreateTicketPermission = userUIControlPermission?.ticketaddscreen
      ? userUIControlPermission.ticketaddscreen.canView
      : true;

    hasUpdateTicketPermission = userUIControlPermission?.ticketupdatescreen
      ? userUIControlPermission.ticketupdatescreen.canView
      : true;

    hasDeleteTicketPermission = userUIControlPermission?.ticketdeletescreen
      ? userUIControlPermission.ticketdeletescreen.canView
      : true;

    hasInfoTicketPermission = userUIControlPermission?.ticketinfoscreen
      ? userUIControlPermission.ticketinfoscreen.canView
      : true;
  }

  // const [columnDefs, setColumnDefs] = useState([]);

  // useEffect(() => {
  //   if (
  //     ticketStatusDropdown?.length > 0 &&
  //     ticketPriorityDropdown?.length > 0 &&
  //     owner?.length > 0
  //   ) {
  //     setColumnDefs([
  //       {
  //         headerName: "Actions",
  //         headerCheckboxSelection: true,
  //         headerCheckboxSelectionFilteredOnly: true,
  //         checkboxSelection: true,
  //         cellRenderer: (params) => {
  //           const paramsValue = { ...params.data };
  //           return (
  //             <OptionButton
  //               rowData={paramsValue}
  //               // openPopup={open}
  //               hasInfoTicketPermission={hasInfoTicketPermission}
  //               hasUpdateTicketPermission={hasUpdateTicketPermission}
  //               hasDeleteTicketPermission={hasDeleteTicketPermission}
  //               handleOpenEditForm={() => handleOpenEditForm(paramsValue)}
  //               handleOpenViewForm={() => handleOpenViewForm(paramsValue)}
  //               handleClickDelete={() => handleClickDelete(paramsValue)}
  //             />
  //           );
  //         },
  //         maxWidth: 100,
  //         minWidth: 100,
  //         sortable: false,
  //         filter: false,
  //         pinned: 'left',

  //       },
  //       {
  //         headerName: "Subject",
  //         field: "subject",
  //         cellRenderer: (params) => {
  //           // Handle grouped rows (grouped rows don't need custom rendering)
  //           if (!params.value || params.node.group) return params.value;

  //           return (
  //             <Link
  //               to={`/tickets/viewTicket?id=${params.data.id}`}
  //               state={params.data}
  //               style={{ fontWeight: "600" }}
  //             >
  //               {params.value}
  //             </Link>
  //           );
  //         },
  //         filter: "agTextColumnFilter",
  //         filterParams: {
  //           buttons: ["apply", "reset"],
  //           closeOnApply: true,
  //           suppressAndOrCondition: true,
  //         },

  //         pinned: isMobile() ? null : "left",
  //         minWidth: 180,
  //       },
  //       {
  //         headerName: "Ticket Owner",
  //         field: "owner",
  //         filter: "agSetColumnFilter",
  //         filterParams: {
  //           values:
  //             owner && owner.length > 0
  //               ? owner.map((item) => item.display_name)
  //               : [],
  //           buttons: ["apply", "reset"],
  //           closeOnApply: true,
  //           defaultToNothingSelected: true, // ✅ Unchecks all records by default
  //           applyButtonDisabled: (params) =>
  //             params.filterModel.values.length === 0,
  //         },
  //       },

  //       {
  //         headerName: "Lead Name",
  //         field: "leadName",
  //         filter: "agTextColumnFilter",
  //         filterParams: {
  //           buttons: ["apply", "reset"],
  //           closeOnApply: true,
  //           suppressAndOrCondition: true,
  //         },
  //       },
  //       {
  //         headerName: "Contact Name",
  //         field: "contactName",
  //         filter: "agTextColumnFilter",
  //         filterParams: {
  //           buttons: ["apply", "reset"],
  //           closeOnApply: true,
  //           suppressAndOrCondition: true,
  //         },
  //       },
  //       {
  //         headerName: "Account Name",
  //         field: "accountName",
  //         filter: "agTextColumnFilter",
  //         filterParams: {
  //           buttons: ["apply", "reset"],
  //           closeOnApply: true,
  //           suppressAndOrCondition: true,
  //         },
  //       },
  //       {
  //         headerName: "Opportunity Name",
  //         field: "opportunityName",
  //         filter: "agTextColumnFilter",
  //         filterParams: {
  //           buttons: ["apply", "reset"],
  //           closeOnApply: true,
  //           suppressAndOrCondition: true,
  //         },
  //       },

  //       {
  //         headerName: "Campaign Name",
  //         field: "campaignName",
  //         filter: "agTextColumnFilter",
  //         filterParams: {
  //           buttons: ["apply", "reset"],
  //           closeOnApply: true,
  //           suppressAndOrCondition: true,
  //         },
  //       },
  //       {
  //         headerName: "Due Date",
  //         field: "dueDate",
  //         filter: "agDateColumnFilter",
  //         filterParams: filterParams,
  //         valueFormatter: DateFormatter,
  //       },
  //       {
  //         headerName: "Status",
  //         field: "status",
  //         filter: "agSetColumnFilter",
  //         filterParams: {
  //           values:
  //             ticketStatusDropdown && ticketStatusDropdown.length > 0
  //               ? ticketStatusDropdown.map((item) => item.displayName)
  //               : [],
  //           buttons: ["apply", "reset"],
  //           closeOnApply: true,
  //           defaultToNothingSelected: true, // ✅ Unchecks all records by default
  //           applyButtonDisabled: (params) =>
  //             params.filterModel.values.length === 0,
  //         },
  //       },
  //       {
  //         headerName: "Priority",
  //         field: "priority",
  //         filter: "agSetColumnFilter",
  //         filterParams: {
  //           values:
  //             ticketPriorityDropdown && ticketPriorityDropdown.length > 0
  //               ? ticketPriorityDropdown.map((item) => item.displayName)
  //               : [],
  //           buttons: ["apply", "reset"],
  //           closeOnApply: true,
  //           defaultToNothingSelected: true, // ✅ Unchecks all records by default
  //           applyButtonDisabled: (params) =>
  //             params.filterModel.values.length === 0,
  //         },
  //       },
  //       {
  //         headerName: "Reminder",
  //         field: "reminder",
  //         filter: false,
  //         filterParams: filterParams,
  //         valueFormatter: DateTimeFormatter,
  //       },
  //       {
  //         headerName: "Description",
  //         field: "description",
  //         filter: "agTextColumnFilter",
  //         filterParams: {
  //           buttons: ["apply", "reset"],
  //           closeOnApply: true,
  //           suppressAndOrCondition: true,
  //         },
  //       },
  //       {
  //         headerName: "Created By",
  //         field: "createdBy",
  //         valueFormatter: NameFormatter,
  //         minWidth: 230,
  //         filter: "agTextColumnFilter",
  //         filterParams: {
  //           buttons: ["apply", "reset"],
  //           closeOnApply: true,
  //         },
  //       },
  //       {
  //         headerName: "Updated By",
  //         field: "updatedBy",
  //         valueFormatter: NameFormatter,
  //         minWidth: 230,
  //         filter: "agTextColumnFilter",
  //         filterParams: {
  //           buttons: ["apply", "reset"],
  //           closeOnApply: true,
  //         },
  //       },
  //       {
  //         headerName: "Created Date Time",
  //         field: "createdDateTime",
  //         valueFormatter: DateTimeFormatter,
  //         minWidth: 230,
  //         filter: "agDateColumnFilter",
  //         filterParams: filterParams,
  //         hide: true,
  //       },
  //       {
  //         headerName: "Updated Date Time",
  //         field: "updatedDateTime",
  //         valueFormatter: DateTimeFormatter,
  //         minWidth: 230,
  //         filter: "agDateColumnFilter",
  //         filterParams: filterParams,
  //         hide: true,
  //       },
  //     ]);}
  // }, [ticketStatusDropdown, ticketPriorityDropdown, loading, owner]);

  const handleClickDelete = (paramsValue) => {
    setLoading(true);

    let data;
    // Creating the desired JSON object
    if (paramsValue.id === undefined) {
      const selectedIds = fullSelection.map((row) => row.id);
      data = { id: selectedIds };
    } else {
      data = {
        id: [paramsValue.id],
      };
    }
    apiServices
      .deleteTicket(data)
      .then((response) => {
        if (response.status === 200) {
          //setUpdateListFlag(true);
          setLoading(false);
          if (paramsValue.id === undefined) {
            document.getElementById('massDeleteModal').click();
          }
          dispatch(
            fetchSelectedListAndAppendToModule({
              key: 'ticketList',
              selectedList: {},
            })
          );
          dispatch(
            fetchDataAndUpdateStore({
              key: 'ticketList',
              inputData: gridData?.inputPayload ? gridData?.inputPayload : ticketInputData,
            })
          );
          toast.success('Ticket Deleted Successfully!', {
            position: 'top-right',
          });
        } else {
          setLoading(false);
          toast.error('Error deleting record', {
            position: 'top-right',
          });
        }
      })
      .catch((error) => {
        console.error('Error deleting record:', error);
        setLoading(false);
      });
  };

  const columnDefs = useTaskColumnDefs({
    hasUpdateTicketPermission,
    hasInfoTicketPermission,
    hasDeleteTicketPermission,
    ticketStatusDropdown,
    ticketPriorityDropdown,
    owner,
    gridData,
    open,
    handleClickDelete,
  });

  const handleColumnChanged = (params) => {
    const columnApi = gridRef.current.columnApi;
    const columnState = columnApi.getColumnState();
    dispatch(
      updateGridColumnState({
        moduleKey: 'ticketList',
        columnState: columnState,
      })
    );
  };
  const handleGridReady = (params) => {
    gridRef.current = params;
    setGridParams(params);
    const columnOrderFromStore = gridData?.columnState;
    if (columnOrderFromStore) {
      params.columnApi.applyColumnState({
        state: columnOrderFromStore,
        applyOrder: true,
      });
    } else {
      // apply default column visibility if no saved state
      const fieldsToHide = ['createdDateTime', 'updatedDateTime'];

      const defaultState = params.columnApi.getColumnState().map((col) => ({
        ...col,
        hide: fieldsToHide.includes(col.colId),
      }));

      params.columnApi.applyColumnState({
        state: defaultState,
        applyOrder: true,
      });
    }
  };

  const statusBar = useMemo(() => {
    return {
      statusPanels: [
        { statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left' },
        { statusPanel: 'agTotalRowCountComponent', align: 'center' },
        { statusPanel: 'agFilteredRowCountComponent' },
        { statusPanel: 'agSelectedRowCountComponent' },
        { statusPanel: 'agAggregationComponent' },
      ],
    };
  }, []);

  const sideBar = useMemo(() => {
    return {
      toolPanels: [
        {
          id: 'columns',
          labelDefault: 'Columns',
          labelKey: 'columns',
          iconKey: 'columns',
          toolPanel: 'agColumnsToolPanel',
          minWidth: 225,
          width: 225,
          maxWidth: 225,
          toolPanelParams: {
            suppressPivotMode: true, // 👈 Hide Pivot Mode toggle
            suppressRowGroups: false, // ✅ Allow row grouping
            suppressValues: false, // ✅ Allow aggregation if needed
            suppressPivots: true, // 👈 Hide the pivot section for columns
          },
        },
        {
          id: 'filters',
          labelDefault: 'Filters',
          labelKey: 'filters',
          iconKey: 'filter',
          toolPanel: 'agFiltersToolPanel',
          minWidth: 180,
          maxWidth: 400,
          width: 250,
        },
      ],
      position: 'left',
      defaultToolPanel: 'none', //show off filter tab bydefault.
    };
  }, []);

  const popupParent = useMemo(() => {
    return document.body;
  }, []);

  const sortingOrder = useMemo(() => {
    return ['desc', 'asc', null];
  }, []);

  const defaultColDef = useMemo(() => ({
    sortable: true,
    editable: false,
    flex: 1,
    minWidth: 130,
    filter: true,
    resizable: true,
    enableValue: true,
    enableRowGroup: true,
    enablePivot: true,
  }));

  const autoGroupColumnDef = useMemo(() => {
    return {
      minWidth: 200,
      pinned: 'left',
    };
  }, []);

  const handleOpenAddForm = () => {
    navigate('/tickets/addTicket');
  };

  const onSelectionChanged = (event) => {
    const gridApi = gridRef.current.api;
    const selectedRowsLocal = gridApi.getSelectedRows();
    const key = 'page-' + gridData?.inputPayload?.pageNumber;

    setSelectedRows(selectedRowsLocal);

    dispatch(
      fetchSelectedListAndAppendToModule({
        key: 'ticketList',
        selectedList: { [key]: selectedRowsLocal },
      })
    );
  };

  const fullSelection = Object.values(gridDataSelection?.ticketList || {}).flat();

  const location = useLocation();

  // const handleOpenEditForm = (paramsValue) => {
  //   // const updatedObject = {
  //   //   ...paramsValue,
  //   //   type: "edit",
  //   // };
  //   navigate("/tickets/editTicket", {
  //     state: paramsValue,
  //   });
  // };

  // const handleOpenViewForm = (paramsValue) => {
  //   navigate(`/tickets/viewTicket?id=${paramsValue.id}`, {
  //     state: paramsValue,
  //   });
  // };

  const onFirstDataRendered = useCallback((params) => {
    gridRef.current.api.paginationGoToPage();
  }, []);

  const cellClickedListener = useCallback((event) => {}, []);

  const filterDefaultSetRef = useRef(null);
  const handleFilterChanged = useCallback(
    (event) => {
      if (filterDefaultSetRef.current) {
        filterDefaultSetRef.current = false;
      } else {
        let filterModel = event.api.getFilterModel();

        const updatedFilterModel = Object.keys(filterModel).reduce((acc, dynamicFilterKey) => {
          let filterData = filterModel[dynamicFilterKey];
          acc[dynamicFilterKey] = filterData;
          return acc;
        }, {});

        console.log('Updated Filter Model:', updatedFilterModel);

        const payload = {
          ...gridData?.inputPayload,
          filterJson: JSON.stringify(updatedFilterModel),
          pageNumber: 1, // Reset to first page on filter change
        };

        console.log('Filter Payload:', payload);

        dispatch(
          fetchDataAndUpdateStore({
            key: 'ticketList',
            inputData: payload,
          })
        );
      }
    },
    [dispatch, gridData?.inputPayload]
  );

  const handleSortChanged = useCallback(
    (event) => {
      const sortModel = event.columnApi
        .getAllDisplayedColumns()
        .map((col) => ({
          colId: col.getColId(),
          sort: col.getSort(),
        }))
        .filter((col) => col.sort);

      console.log('Sort Model:', sortModel);
      const columnName = sortModel.length > 0 ? sortModel[0].colId : 'UpdatedDateTime';
      const orderType = sortModel.length > 0 ? sortModel[0].sort : 'desc';

      const payload = {
        ...gridData?.inputPayload,
        columnName,
        orderType,
        pageNumber: 1, // Reset to first page on sort change
      };

      dispatch(
        fetchDataAndUpdateStore({
          key: 'ticketList',
          inputData: payload,
        })
      );
    },
    [dispatch, gridData?.inputPayload]
  );

  const exportAll = async () => {
    setLoading(true);
    const fetchData = {
      ...ticketInputData,
      pageSize: gridData?.totalCount,
      searchText: gridData?.inputPayload?.searchText ? gridData?.inputPayload?.searchText : null,
      filterJson: gridData?.inputPayload?.filterJson ? gridData?.inputPayload?.filterJson : null,
    };

    try {
      const response = await apiServices.exportAllTicket(fetchData);

      if (response?.data && response.status === 200) {
        setLoading(false);
        if (response?.data.includes('Export initiated.')) {
          toast.warning(response?.data); // Show toast
          setLoading(false);
        } else {
          // Convert data to Blob for better handling
          const blob = new Blob([response.data], {
            type: 'text/csv;charset=utf-8;',
          });
          const url = URL.createObjectURL(blob);

          // Create and trigger download
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'Tickets.csv');
          document.body.appendChild(link);
          link.click();

          // Cleanup
          document.body.removeChild(link);
          URL.revokeObjectURL(url); // Free memory
        }
      } else {
        console.error('No data received from API.');
        setLoading(false);
      }
    } catch (error) {
      console.error('Error exporting Tickets:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (updateListFlag) {
      const columnName = updateListFlag === false ? 'name' : 'UpdatedDateTime';
      const orderType = updateListFlag === false ? 'asc' : 'desc';
      const data = {
        ColumnName: columnName,
        OrderType: orderType,
        PageNumber: 1,
        PageSize: parseInt(process.env.REACT_APP_DEFAULT_PAGESIZE),
      };
      setUpdateListFlag(false);
      dispatch(
        fetchDataAndUpdateStore({
          key: 'ticketList',
          inputData: gridData?.inputPayload ? gridData?.inputPayload : ticketInputData,
        })
      );
    }
  }, [dispatch, updateListFlag]);

  // Restore selection on rowData change
  useEffect(() => {
    const gridApi = gridParams?.api;
    if (!gridApi || !gridData?.inputPayload?.pageNumber) return;

    const pageKey = 'page-' + gridData.inputPayload.pageNumber;
    const selectedRowsDefault = gridDataSelection?.ticketList?.[pageKey] || [];

    if (selectedRowsDefault.length > 0) {
      gridApi.forEachNode((node) => {
        const isSelected = selectedRowsDefault.some((row) => row.id === node.data?.id);
        node.setSelected(isSelected);
      });
    } else {
      gridApi.deselectAll(); // Optional: clear selection
    }
  }, [gridParams, rowData, location.pathname]);

  useEffect(() => {
    setLoading(storeLoading);
  }, [storeLoading]);

  return (
    <div className="inner-page" style={containerStyle}>
      <div className="dash-container">
        <div className="tbl_container">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-12">
              {fullSelection.length > 0 ? (
                <div className="main-hd">
                  <div className="left_lead">
                    <div className="heading_item topLink" id="actiongrid_dropdown">
                      <div className="dropdown">
                        <button
                          className="btn action-btn dropdown-toggle "
                          type="button"
                          id="dropdownMenuButton"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          Actions
                        </button>

                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <li
                            className="dropdown-item"
                            data-bs-toggle="modal"
                            data-bs-target="#delete"
                          >
                            Delete
                          </li>
                        </ul>
                      </div>
                    </div>

                    {/* Modal structure Delete */}
                    <div id="dropdown_modal">
                      <div
                        className="modal fade"
                        id="delete"
                        tabIndex="-1"
                        aria-labelledby="modalLabel"
                        aria-hidden="true"
                      >
                        <div className="modal-dialog">
                          <div className="modal-content">
                            <div className="warning-content">
                              <div className="warningOuter">
                                <div className="alertImg">
                                  <img
                                    src="../assets/images/delete-record.png"
                                    alt="Delete Record"
                                  ></img>
                                </div>
                                <div className="warningText">
                                  Are you sure you want to delete the selected record?
                                </div>
                              </div>
                              <div className="notes">
                                *Note: Any associated Activities, Visits, Drafts will also be
                                Deleted.
                              </div>
                              <div className="warningBtn mt-2">
                                <Button
                                  variant="secondary"
                                  className="btn"
                                  data-bs-dismiss="modal"
                                  id="massDeleteModal"
                                >
                                  Cancel
                                </Button>
                                <Button
                                  className="btn"
                                  variant="danger"
                                  onClick={handleClickDelete}
                                >
                                  Confirm Delete
                                </Button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Modal structure Email  */}
                  </div>
                  <div className="third-div dsk">
                    <div className="heading_item">
                      <div className="dsk">
                        <GlobalSearch moduleName={'ticketList'} fullSelection={fullSelection} />
                      </div>
                    </div>
                    <div className="heading_item text-bld">
                      <label></label>
                    </div>
                    <div className="heading_item text-bld"></div>
                    <div className="heading_item text-bld crsr"></div>
                  </div>
                </div>
              ) : (
                <div className="main-hd">
                  <div className="pagetitle">
                    <img src="../assets/images/role-management-icons/left-arrow.png" alt="" />
                    Tickets
                  </div>
                  <div className="third-div mobView">
                    <div className="dsk">
                      <GlobalSearch moduleName={'ticketList'} fullSelection={fullSelection} />
                    </div>

                    <button
                      onClick={exportAll}
                      className="btn btn-outline-primary mobOption export-btn"
                      type="button"
                      disabled={rowData && rowData.length === 0}
                    >
                      <svg
                        width="16px"
                        height="16px"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 5L11.2929 4.29289L12 3.58579L12.7071 4.29289L12 5ZM13 14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14L13 14ZM6.29289 9.29289L11.2929 4.29289L12.7071 5.70711L7.70711 10.7071L6.29289 9.29289ZM12.7071 4.29289L17.7071 9.29289L16.2929 10.7071L11.2929 5.70711L12.7071 4.29289ZM13 5L13 14L11 14L11 5L13 5Z"
                          fill="#333333"
                        />
                        <path
                          d="M5 16L5 17C5 18.1046 5.89543 19 7 19L17 19C18.1046 19 19 18.1046 19 17V16"
                          stroke="#333333"
                          strokeWidth="2"
                        />
                      </svg>{' '}
                      <div className="dsk"> Export</div>
                    </button>

                    {hasCreateTicketPermission && (
                      <button
                        className="btn btn-primary createTkt"
                        type="button"
                        onClick={handleOpenAddForm}
                      >
                        Create Tickets
                      </button>
                    )}
                  </div>
                </div>
              )}
              <div className="mob mb-3">
                <GlobalSearch moduleName={'ticketList'} />
              </div>
              <div className="cutome_ag_theme">
                {loading && <Loader />}
                <div
                  className={`ag-theme-${selectedTheme} tbl_height`}
                  style={{ width: '100%', height: `100%` }}
                >
                  {gridLoading ? (
                    <CustomLoadingOverlay loadingMessage="Loading..." />
                  ) : (
                    <AgGridReact
                      className="ag-grid-container" // Add a class for styling
                      domLayout="fixedHeight"
                      ref={gridRef} // Ref for accessing Grid's API
                      rowData={rowData} // Row Data for Row
                      columnDefs={columnDefs}
                      autoGroupColumnDef={autoGroupColumnDef}
                      defaultColDef={defaultColDef} // Default Column Properties
                      overlayLoadingTemplate={`<Loader />`}
                      animateRows={true} // Optional - set to 'true' to have rows animate when sorted
                      rowSelection={'multiple'} // Options - allows click selection of rows
                      sideBar={sideBar} // pass side by making interface
                      enableRangeSelection={true}
                      suppressExcelExport={true}
                      suppressRowClickSelection={true}
                      groupSelectsChildren={true}
                      pivotPanelShow={'always'}
                      popupParent={popupParent}
                      onFirstDataRendered={onFirstDataRendered}
                      onCellClicked={cellClickedListener} // Optional - registering for Grid Event
                      rowDragManaged={true}
                      suppressMoveWhenRowDragging={true}
                      rowGroupPanelShow={'always'}
                      onFilterChanged={handleFilterChanged}
                      gridOptions={gridOptions}
                      onSelectionChanged={onSelectionChanged}
                      onSortChanged={handleSortChanged}
                      onGridReady={handleGridReady}
                      onColumnMoved={handleColumnChanged}
                      onColumnVisible={handleColumnChanged}
                    />
                  )}
                  {gridParams && (
                    <FilterHandler
                      params={gridParams}
                      gridData={gridData}
                      columnDefs={columnDefs}
                      filterDefaultSetRef={filterDefaultSetRef}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Tasks;
